module.exports = __webpack_public_path__ + "img/check-mark-green.379b2908.svg";